import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronRight, Circle } from 'lucide-react';

const SidebarNav = ({ navItems = [], collapsed = false, user }) => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (heading) => {
    setExpandedSections((prev) => ({
      ...prev,
      [heading]: !prev[heading],
    }));
  };

  const isPrivilegedUser = user && user.email === 'rrose@babsusa.com';

  return (
    <div className="space-y-6 ">
      {navItems.map((item, index) => {
        // Skip "Main" section for non-privileged users
        if (item.heading === 'Main' && !isPrivilegedUser) {
          return null;
        }

        const isOpen = expandedSections[item.heading];
        const Icon = item.icon || Circle;

        return (
          <div key={index}>
            <div
              className="flex items-center justify-between cursor-pointer text-white hover:text-gray-300"
              onClick={() => toggleSection(item.heading)}
            >
              <div className="flex items-center space-x-3">
                <Icon size={25} />
                {!collapsed && (
                  <span className="text-sm font-bold uppercase tracking-wide">
                    {item.heading}
                  </span>
                )}
              </div>
              {!collapsed && (isOpen ? <ChevronDown size={20} /> : <ChevronRight size={20} />)}
            </div>

            {!collapsed && isOpen && (
              <ul className="pl-[37px] mt-2 space-y-2">
                {item.links.map((link, i) => (
                  <li key={i}>
                    <Link
                      to={link.path}
                      className="block text-white hover:text-gray-300 transition text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SidebarNav;